import React, { Component } from 'react';
import numeral from 'numeral';
import PropTypes from 'prop-types';
import {
  currentSurveySelector,
  showValidationMessageSelector,
  surveyFormSelector,
} from 'components/admin/surveys/store/selectors';
import { connect } from 'react-redux';
import {
  changeAttribute,
  getSurvey,
  goToSurveys,
  setSurveyForm,
  submitSurvey,
} from 'components/admin/surveys/store/actions';
import SurveyForm from 'components/admin/surveys/SurveyForm';
import { getCurrentUser } from 'selectors/authentication';
import { TYPES, usersUtil } from 'services/utils/users-util';
import { Survey } from 'domain/survey';

class SurveyDetails extends Component {
  static propTypes = {
    currentSurvey: PropTypes.shape({}),
    match: PropTypes.shape({}).isRequired, // from router
    showValidationMessage: PropTypes.bool.isRequired,
    surveyForm: PropTypes.shape({}),
    onSurveyEditSubmit: PropTypes.func.isRequired,
    onSurveyFormAttributeChange: PropTypes.func.isRequired,
    onSurveyFormSet: PropTypes.func.isRequired,
    onSurveyGet: PropTypes.func.isRequired,
  };

  static defaultProps = {
    currentSurvey: null,
    surveyForm: null,
  };

  constructor(props) {
    super(props);
    this.surveyId = numeral(props.match.params.id).value();
  }

  componentDidMount() {
    const { currentSurvey, onSurveyFormSet, onSurveyGet } = this.props;
    if (currentSurvey === null || currentSurvey.id !== this.surveyId) {
      onSurveyGet(this.surveyId);
    } else {
      // If already loaded, update the form with the survey
      onSurveyFormSet(currentSurvey);
    }
  }

  handleAttributeChange = (attribute, value) => {
    this.props.onSurveyFormAttributeChange(attribute, value);
  };

  render() {
    const {
      currentSurvey,
      currentUser,
      showValidationMessage,
      surveyForm,
      onSurveyEditCancel,
      onSurveyEditSubmit,
    } = this.props;
    const isClient = usersUtil.hasType(currentUser, TYPES.CLIENT);
    if (currentSurvey !== null && currentSurvey.id === this.surveyId) {
      if (isClient && Survey.isEditable(currentSurvey)) {
        // If editable, make sure the form is loaded
        if (surveyForm !== null) {
          return (
            <SurveyForm
              edit={true}
              showValidationMessage={showValidationMessage}
              survey={surveyForm}
              onAttributeChange={this.handleAttributeChange}
              onCancel={() => onSurveyEditCancel()}
              onSubmit={() => onSurveyEditSubmit(surveyForm)}
            />
          );
        }
        return null;
      }
      return <SurveyForm edit={false} survey={currentSurvey} />;
    }
    return null;
  }
}

const mapStateToProps = (state) => {
  return {
    currentSurvey: currentSurveySelector(state),
    currentUser: getCurrentUser(state),
    showValidationMessage: showValidationMessageSelector(state),
    surveyForm: surveyFormSelector(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onSurveyFormAttributeChange: (attribute, value) => {
    dispatch(changeAttribute(attribute, value));
  },
  onSurveyEditCancel: () => {
    dispatch(goToSurveys());
  },
  onSurveyEditSubmit: (surveyForm) => {
    dispatch(submitSurvey(surveyForm));
  },
  onSurveyFormSet: (survey) => {
    dispatch(setSurveyForm(survey));
  },
  onSurveyGet: (surveyId) => {
    dispatch(getSurvey(surveyId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SurveyDetails);



// WEBPACK FOOTER //
// ./src/components/admin/surveys/SurveyDetails.js